import {handleActions} from 'redux-actions'
import {CHANGE_ACTIVE_CUSTOMER, START_SESSION_FINISH, END_SESSION_LOSSASS} from '../constants/ActionTypes'

const reducers = {}

/**
 * Handles changing the active customer.
 * Sets the active customer if provided.
 * Resets to default if not provided.
 */
reducers[CHANGE_ACTIVE_CUSTOMER] = {
	next(state, action) {
		// If another user was selected, change to them.
		if (!action.payload.requestId)
			return ''

		return action.payload.requestId
	}
}

reducers[START_SESSION_FINISH] = {
	next (state, action) {
		if(!action.error){
			return action.payload.serviceRequest._id
		}
		else{
			return state
		}

	},
	throw() {
		return ''
	}
}


reducers[END_SESSION_LOSSASS] = {
    next(state, action) {
        return ''
    }
}

export default handleActions(reducers, '')
